import { ErrorBaseData } from '.'

export const uploadedFileErrors: Record<string, ErrorBaseData> = {
  PdfSanitizationFailedException: {
    message: 'Não foi possível enviar os arquivos',
    description: 'Reduza a quantidade de PDFs para até 5 e tente novamente',
  },
}
